import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import ThemeThreeContactForm from '../common/ThemeThreeContactForm';
import ThemeThreeTitle from '../common/ThemeThreeTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeThreeServiceScreen = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	return (
		<div>
			<KuposHelmet />

			<HeroSection
				heroImage={getIcons('serviceBanner', operator)}
				title="Servicios"
				description="Home / Servicios"
				height={'45vh'}
			/>

			<ThemeThreeTitle operator={operator} title="Conoce nuestros servicios" />

			<ThemeThreeContactForm service />
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeThreeServiceScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/ThemeThreePages/ThemeThreeServiceScreen.js